import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_FAXES_REQUEST: '',
  GET_FAXES_SUCCESS: '',
  GET_FAXES_FAILURE: '',

  GET_FAX_STATUS_REQUEST: '',
  GET_FAX_STATUS_SUCCESS: '',
  GET_FAX_STATUS_FAILURE: '',
};

types = setStoreTypeValues(types, 'authFaxes');

export default types;
